import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/hd.vue
var o = {
	name: "DtIconHd",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--hd"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Hd",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1 9.5A1.5 1.5 0 0 0 2.5 11h7c.826 0 1.5-.674 1.5-1.5v-7c0-.826-.674-1.5-1.5-1.5h-7A1.5 1.5 0 0 0 1 2.5v7Zm1.5.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h7c.274 0 .5.226.5.5v7c0 .274-.226.5-.5.5h-7Zm.75-2a.5.5 0 0 0 .5-.5v-1h1v1a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-1 0v1h-1v-1a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .5.5Zm3-.5a.5.5 0 0 0 .5.5h.5a2 2 0 1 0 0-4h-.5a.5.5 0 0 0-.5.5v3Zm1-.5V5a1 1 0 0 1 0 2Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=hd.js.map